import { ApiElementDeviation, isDeviationScanResult } from "avvir";

import DetailedElement from "../../models/domain/detailed_element";
import PlannedBuildingElement from "../../models/domain/planned_building_element";

class PlannedBuildingElementConverter {
  static detailedElementToPlannedBuildingElement(detailedElement: DetailedElement) {
    let deviation: ApiElementDeviation = null;
    if (isDeviationScanResult((detailedElement.scanResult))) {
      deviation = detailedElement.scanResult.deviation;
    }
    return new PlannedBuildingElement({
      ...detailedElement,
      deviation,
    });
  }
}

export default PlannedBuildingElementConverter;
